export default __webpack_public_path__ + "static/media/green_2.124b849c.png";